import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyAgencyApprovals = createSelector(
  selectSubCompany,
  subCompany => subCompany?.agencyApprovals ?? null,
);
